import { render, staticRenderFns } from "./ContainerUploadDoc.vue?vue&type=template&id=1d38f2de&scoped=true&"
import script from "./ContainerUploadDoc.vue?vue&type=script&lang=js&"
export * from "./ContainerUploadDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d38f2de",
  null
  
)

export default component.exports